/* LUZ NOVA — wishlist (localStorage, no app required) */
(function () {
  "use strict";
  const KEY = "luz:wishlist";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  };
  const write = (list) => {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateBadge();
  };
  const has = (handle) => read().includes(handle);
  const toggle = (handle) => {
    const list = read();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    else list.unshift(handle);
    write(list);
    return i < 0;
  };

  function updateBadge() {
    const n = read().length;
    document.querySelectorAll("[data-wishlist-count]").forEach((el) => {
      el.textContent = n;
      if (n === 0) el.setAttribute("data-zero", "");
      else el.removeAttribute("data-zero");
    });
  }

  function paintButtons(root) {
    (root || document).querySelectorAll("[data-wishlist-toggle]").forEach((btn) => {
      btn.classList.toggle("is-active", has(btn.dataset.handle));
    });
  }

  /* Event delegation so JS-rendered cards work too */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    e.preventDefault();
    const added = toggle(btn.dataset.handle);
    btn.classList.toggle("is-active", added);
    const label = btn.querySelector("[data-wishlist-label]");
    if (label) label.textContent = added ? "Saved" : "Save";
  });

  /* Wishlist page renderer */
  async function renderPage() {
    const wrap = document.getElementById("WishlistGrid");
    if (!wrap) return;
    const empty = document.getElementById("WishlistEmpty");
    const handles = read();
    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    const products = await Promise.all(
      handles.map((h) =>
        fetch("/products/" + h + ".js")
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    );
    const live = products.filter(Boolean);
    /* prune deleted products */
    write(live.map((p) => p.handle));
    if (!live.length) {
      if (empty) empty.hidden = false;
      return;
    }
    wrap.innerHTML = live.map((p) => window.LuzCard(p)).join("");
    paintButtons(wrap);
  }

  window.LuzWishlist = { refresh: () => { paintButtons(); updateBadge(); }, has: has };

  document.addEventListener("DOMContentLoaded", () => {
    updateBadge();
    paintButtons();
    renderPage();
  });
})();
